
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M23.15 14.13a2.1 2.1 0 00.15-.69 5.62 5.62 0 00-9.37-4.19v12.31h8.57a3.74 3.74 0 00.65-7.43z"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M11.25 10.31v10.94"}}),_c('path',{attrs:{"stroke-width":"1.2","data-name":"thin","d":"M8.75 14.69v6.56M6.25 13.44v7.81M3.75 17.19v4.06"}})])])
          )
        }
      }
    